const scopes = Object.freeze({
  days: 'days',
});

export const reports = Object.freeze([
  {
    id: 'agp',
    scope: scopes.days,
  },
  /*
  {
    id: 'insulin',
    scope: scopes.days,
  },
  {
    id: 'nutrition',
    scope: scopes.days,
  },
  {
    id: 'exercise',
    scope: scopes.days,
  },
  {
    id: 'diary',
    scope: scopes.days,
  },
  */
  {
    id: 'day',
    scope: scopes.days,
  },
]);

export const defaultLocale = ((document.location.search.match(/(\?|&)locale=(.[^&]+)/) || [])[2])
|| (document.location.href.indexOf('sensotrend.fi') >= 0
? 'fi'
: 'en-GB'
);
